import { AbstractControl, FormControl, ValidationErrors } from '@angular/forms';

export const ValidateApikey = (control: AbstractControl | FormControl): ValidationErrors | null => {
  const value = control.value;
  if (!value) {
    return null; // No value, no validation
  }

  // Example validation: apikey must be exactly 32 characters long and alphanumeric
  const isValid = typeof value === 'string' && /^[a-zA-Z0-9]{32}$/.test(value);

  return isValid ? null : { invalidApikey: true };
};
